import { useState, useContext, createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("site") || "");
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  const googleLogin = (token) => {
    try {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setUser(res.data);
          console.log(res.data);
          //TODO: Replace this token with a hash token or secret exchange token
          setToken(token);
          localStorage.setItem("site", token);
          navigate("/homepage");
        })
        .catch((err) => {
          console.log("Google Login Error: " + err);
        });
    } catch (error) {
      console.log("Login Failed: ", error);
    }
  };

  const standardLogin = () => {
    try {
    } catch (error) {}
  };

  const logout = async () => {
    try {
      googleLogout();
      setUser(null);
      setToken("");
      localStorage.removeItem("site");
      navigate("/landingpage");
    } catch (error) {
      console.log("Logout Failed: ", error);
    }
  };

  return (
    <AuthContext.Provider
      value={{ token, user, googleLogin, standardLogin, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
